// @flow strict

import * as React from 'react';
import styles from './styles.scss';
import PageContentBlock from '../../internal/PageContentBlock';
import Iframe from '../Iframe';

type PropTypes = {|
  title?: string,
  intro?: string,
  zoomId: string,
  height: string,
|};

const Zoom = (props: PropTypes) => {
  return (
    <PageContentBlock title={props.title} intro={props.intro} layout="Thin">
      <div className={styles.zoom}>
        <Iframe
          src={`https://zoom.us/webinar/register/${props.zoomId}`}
          appliedMinHeight
          height={props.height}
          title="Zoom registration form"
        />
      </div>
    </PageContentBlock>
  );
};

export default Zoom;
